<template>
  <div class="payment-result-page">
    <navbar-home />

    <div class="container ew-page-container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6">
          <div class="ew-result-card text-center shadow-lg p-5">

            <div v-if="result === 'loading'">
              <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status"></div>
              <h3 class="h3 mt-3">Procesando Pago...</h3>
              <p class="text-muted">Por favor, espera un momento. Estamos verificando la transacción.</p>
            </div>

            <div v-else-if="result === 'success'">
              <i class="bi bi-check-circle-fill ew-result-icon text-success mb-4"></i>
              <h2 class="h2 text-success font-weight-bold border-bottom pb-3 mb-4">¡Pago Exitoso!</h2>
              <p class="lead text-dark mb-4">
                <span v-if="from">
                  ¡Tu pago ha sido procesado con <strong>éxito</strong>! Hemos enviado la guía a tu correo:
                  <br><strong class="text-primary">{{ email }}</strong>
                </span>
                <span v-else-if="paymentMonedero">
                  ¡El pago se ha realizado <strong>correctamente</strong> desde tu monedero!
                </span>
                <span v-else-if="paymentConekta">
                  ¡Hemos enviado los detalles de pago de referencia a tu correo:
                  <br><strong class="text-primary">{{ email }}</strong>
                </span>
                <span v-else>
                  Tu transacción se ha completado con éxito.
                </span>
              </p>

              <div class="d-flex flex-column flex-sm-row justify-content-center gap-3 mt-4">
                <router-link :to="isLoging ? '/dashboard' : '/'" class="btn btn-primary btn-lg">
                  Volver al Inicio
                </router-link>

                <router-link v-if="paymentConekta" :to="'/shipping/cash_barcode?references=' + reference"
                  target="_blank" class="btn btn-outline-secondary btn-lg">
                  <i class="bi bi-receipt mr-2"></i> Ver Referencia de Pago
                </router-link>
              </div>
            </div>

            <div v-else-if="result === 'error'">
              <!-- La paquetería rechazó la guía antes de cobrar: no es un pago declinado -->
              <template v-if="isGuideError">
                <i class="bi bi-exclamation-circle-fill ew-result-icon text-warning mb-4"></i>
                <h2 class="h2 text-dark font-weight-bold border-bottom pb-3 mb-4">No se pudo generar la guía</h2>
                <p class="lead text-dark mb-3">{{ errorReason || 'La paquetería no aceptó la guía.' }}</p>
                <p class="ew-no-charge mb-4">
                  <i class="bi bi-shield-check mr-2"></i>No se realizó ningún cargo{{ methodLabel ? ' a tu ' + methodLabel : '' }}.
                  Corrige el dato indicado e inténtalo de nuevo.
                </p>
              </template>
              <template v-else>
                <i class="bi bi-x-circle-fill ew-result-icon text-danger mb-4"></i>
                <h2 class="h2 text-danger font-weight-bold border-bottom pb-3 mb-4">Pago declinado</h2>
                <p class="lead text-dark mb-3">
                  Hemos registrado un error durante el proceso de pago.
                </p>
              </template>

              <router-link :to="isGuideError ? '/dashboard/shipment/new' : '/dashboard'" class="btn btn-primary btn-lg mt-2">
                <i class="bi bi-arrow-clockwise mr-2"></i> Intentar de nuevo
              </router-link>
            </div>


            <!-- DETALLE DEL JSON DE ERROR -->
            <div v-if="paymentData" class="alert alert-danger text-left mb-4 p-3 shadow-sm">

              <!-- Si hay un error de recolección con días disponibles -->
              <div v-if="paymentData.pickup_error">
                <hr class="my-2">
                <p class="mb-1 text-danger font-weight-bold">
                  {{ paymentData.pickup_error.message }}:
                </p>
                <p class="mb-2 text-muted small">
                  {{ paymentData.pickup_error.error && paymentData.pickup_error.error.error ?
                    paymentData.pickup_error.error.error : '' }}
                </p>

                <div v-if="paymentData.pickup_error.error && paymentData.pickup_error.error.availability_days">
                  <p class="mb-1 font-weight-bold small">Días disponibles para recolección:</p>
                  <ul class="list-unstyled pl-3 mb-0 small">
                    <li v-for="(day, index) in paymentData.pickup_error.error.availability_days" :key="index">
                      <i class="bi bi-calendar-event mr-1 text-primary"></i> {{ day.day }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import AppFooter from "@/components/AppFooter.vue";
import NavbarHome from "@/components/Header/NavbarHome.vue";
import axios from 'axios'
import commons from '../commons'

export default {
  name: 'PaymentResult',
  data() {
    return {
      result: 'loading',
      from: '',
      email: '',
      paymentConekta: '',
      paymentMonedero: '',
      isLoging: false,
      reference: '',
      paymentData: null
    }
  }, created() {
    this.getStatusSesion();
    this.from = (this.$route.query.home === 'true') ? true : false
    this.email = this.$route.query.email
    this.result = this.$route.params['result']
    this.paymentConekta = (this.$route.query.oxxo === 'true') ? true : false
    this.paymentMonedero = (this.$route.query.monedero === 'true') ? true : false
    if (this.$route.query.reference) {
      this.reference = this.$route.query.reference
    }

    console.log("=== PAYMENT RESULT DEBUG ===");
    console.log("Route params (result):", this.$route.params['result']);
    console.log("Route query:", this.$route.query);

    const savedData = localStorage.getItem('paymentResponseData');
    console.log("Raw paymentResponseData from localStorage:", savedData);

    if (savedData) {
      try {
        this.paymentData = JSON.parse(savedData);
        console.log("Parsed paymentData object:", this.paymentData);
      } catch (e) {
        console.error("Error al parsear el JSON de pago:", e);
      }
    } else {
      console.warn("No se encontró 'paymentResponseData' en el localStorage.");
    }
  },
  methods: {
    getStatusSesion() {
      if (localStorage.getItem('ew-user-id') !== null) {
        this.isLoging = true;
      } else {
        this.isLoging = false;
      }
    },
    getShipment(id) {
      const url = `${commons.apiURL}/api/v1/shipments/${id}`
      return axios.get(url)
    },
    pay(paymentMethod) {
      let myWindow = null
      if (paymentMethod === 'paypal') {
        axios
          .post(`${commons.apiURL}/api/v1/payments/${this.shipmentId}`)
          .then(response => {
            myWindow = window.open(
              response.data.url,
              'SackEnvios - PayPal',
              'centerscreen,modal'
            )
            myWindow.focus()
          })
      }
    },
  },
  mounted() { localStorage.removeItem('paymentResponseData'); },
  computed: {
    isGuideError() {
      return this.$route.query.stage === 'guide';
    },
    errorReason() {
      const error = this.$route.query.error;
      // Solo se muestra un motivo legible; los errores técnicos se ocultan
      if (!error || /request failed|typeerror|cannot read|status code/i.test(error)) return '';
      return error;
    },
    methodLabel() {
      return { monedero: 'monedero', card: 'tarjeta' }[this.$route.query.method] || '';
    }
  },
  components: {
    AppFooter,
    "navbar-home": NavbarHome
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ew-result-icon {
  display: inline-block;
  font-size: 4.5rem;
  line-height: 1;
}

.ew-no-charge {
  display: inline-block;
  padding: 10px 14px;
  border: 1px solid #bfe5cc;
  border-radius: 8px;
  background: #effaf3;
  color: #15803d;
  font-size: 0.9rem;
  font-weight: 500;
}

@import "../assets/styles/variables";

.payment-result-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.ew-page-container {
  flex: 1 0 auto;
}

.h3 {

  font-weight: 600;
}

.ew-smaller-container {
  max-width: 600px;
  margin-top: 6rem;

  .ew-inner-container {
    min-height: 20vmax;
  }

  .ew-result-indicator {
    width: 5rem;
  }

  .ew-social-icon {
    width: 1rem
  }
}

.footer {
  height: 150px;
  background-size: contain;
  background-repeat: repeat;
}

.ew-custom-control {
  border: 1px solid $gray-400;
  border-radius: $border-radius-lg;
  margin-bottom: 1rem;
  padding: 1rem;

  label {
    display: block;
  }
}

.ew-navbar {
  .btn {
    font-size: 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentResult.vue